import type { IUseCase } from '@/shared/contracts/use-case.contract';
import { HttpMethod, type IHttpClient } from '@/shared/contracts/http-client.contract';

import { CLUB_ENDPOINT, type ClubSlugRequest, type ClubSummary } from '../types/club';

export class GetClubSummaryUseCase implements IUseCase<ClubSlugRequest, ClubSummary> {
  private client: IHttpClient;

  constructor(client: IHttpClient) {
    this.client = client;
  }

  async execute({ slug }: ClubSlugRequest): Promise<ClubSummary> {
    if (!slug) throw new Error('Slug is required');

    return this.client.sendRequest<ClubSummary, never>({
      method: HttpMethod.GET,
      endpoint: CLUB_ENDPOINT(slug),
    });
  }
}
